import { render, staticRenderFns } from "./BtnAtualizarMovimentacao.vue?vue&type=template&id=530ea6af&"
import script from "./BtnAtualizarMovimentacao.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports